import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PresentationViewer from "./components/presentation/PresentationViewer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PresentationViewer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
